import React, { useEffect, useState } from "react";
import {
  getWallets,
  initiateWalletFunding,
  processWalletFunding,
  initiateWalletSwap,
  processWalletSwap,
  initiateCryptoTransfer,
  processCryptoTransfer,
} from "../apiWallets";
import api from "../api";
import {
  MenuItem,
  Select,
  CircularProgress,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CloseIcon from "@mui/icons-material/Close";
import Preloader from "../components/Preloader";
import { FaBitcoin, FaDollarSign, FaSterlingSign } from "react-icons/fa6";
import { SiTether } from "react-icons/si";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useWallet } from "../api/hooks/useWallet";
import { getOrganizationSettings, getUser } from "../utils/storage";
import { useExchangeRate } from "../api/hooks/useExchangeRate";
import { useWalletTransactions } from "../api/hooks/useWalletTransactions";
import { useAppDispatch } from "../redux/hook.js";
import { getWalletTransactions } from "../api/wallet";
import { getExchangeRate } from "../api/exchangeRate";
import { moneyFormat } from "../utils/utils";
import { useNavigate } from "react-router-dom";
import { useOrganizationSettings } from "../api/hooks/organizationSettings";
import TransactionDetailsDialog from "../components/transactionDetailsDialog";
import StatusPill from "../components/statusPill";

export default function Dashboard({ setSidebarOpen = null }) {
  const [error, setError] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [txLoading, setTxLoading] = useState(true);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [overviewCurrency, setOverviewCurrency] = useState("NGN");
  const [overviewTotal, setOverviewTotal] = useState(0);
  const [overviewLoading, setOverviewLoading] = useState(false);
  const [showBalances, setShowBalances] = useState({});
  const [walletDetailsOpen, setWalletDetailsOpen] = useState(false);
  const [selectedWalletForDetails, setSelectedWalletForDetails] =
    useState(null);
  const [selectedWalletTransactions, setSelectedWalletTransactions] = useState(
    []
  );
  const [selectedWalletTxLoading, setSelectedWalletTxLoading] = useState(false);
  const [allTransactionsOpen, setAllTransactionsOpen] = useState(false);
  const [allTransactions, setAllTransactions] = useState([]);
  const [allTransactionsLoading, setAllTransactionsLoading] = useState(false);
  const [ratesOpen, setRatesOpen] = useState(false);
  const [rates, setRates] = useState({});
  const [activeTab, setActiveTab] = useState("all");
  const [swapFromCurrency, setSwapFromCurrency] = useState("USDT");
  const [swapToCurrency, setSwapToCurrency] = useState("USD");
  const [swapFromAmount, setSwapFromAmount] = useState("");
  const [swapToAmount, setSwapToAmount] = useState("");
  const [swapLoading, setSwapLoading] = useState(false);
  const [swapError, setSwapError] = useState("");
  const [userBalances, setUserBalances] = useState({});
  const [realRates, setRealRates] = useState({});
  const [ratesLoading, setRatesLoading] = useState(false);
  const supportedCurrencies = ["NGN", "USD", "GBP"];

  // Swap dialog state
  const [swapDialogOpen, setSwapDialogOpen] = useState(false);
  const [swapStep, setSwapStep] = useState(1);
  const [swapFromWallet, setSwapFromWallet] = useState(null);
  const [swapToWallet, setSwapToWallet] = useState(null);
  const [swapDescription, setSwapDescription] = useState("");
  const [swapPin, setSwapPin] = useState("");
  const [swapResult, setSwapResult] = useState(null);
  const [showSwapPin, setShowSwapPin] = useState(false);

  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [open, setOpen] = useState(false);


  // Crypto transfer dialog state
  const [cryptoTransferDialogOpen, setCryptoTransferDialogOpen] =
    useState(false);
  const [cryptoTransferStep, setCryptoTransferStep] = useState(1);
  const [cryptoTransferSourceWallet, setCryptoTransferSourceWallet] =
    useState(null);
  const [cryptoTransferAmount, setCryptoTransferAmount] = useState("");
  const [
    cryptoTransferDestinationAddress,
    setCryptoTransferDestinationAddress,
  ] = useState("");
  const [cryptoTransferNetwork, setCryptoTransferNetwork] = useState("TRC20");
  const [cryptoTransferDescription, setCryptoTransferDescription] =
    useState("");
  const [cryptoTransferPin, setCryptoTransferPin] = useState("");
  const [cryptoTransferResult, setCryptoTransferResult] = useState(null);
  const [showCryptoTransferPin, setShowCryptoTransferPin] = useState(false);
  const [cryptoTransferLoading, setCryptoTransferLoading] = useState(false);
  const [cryptoTransferError, setCryptoTransferError] = useState("");

  const navigate = useNavigate();

  // --- FUNDING DIALOG STATE (add after other useState hooks) ---
  const [fundDialogOpen, setFundDialogOpen] = useState(false);
  const [fundStep, setFundStep] = useState(1);
  const [fundWallet, setFundWallet] = useState(null);
  const [fundAmount, setFundAmount] = useState("");
  const [fundCurrency, setFundCurrency] = useState("NGN");
  const [fundDesc, setFundDesc] = useState("");
  const [fundPin, setFundPin] = useState("");
  const [funding, setFunding] = useState(false);
  const [fundError, setFundError] = useState("");
  const [fundResult, setFundResult] = useState(null);
  const [showFundPin, setShowFundPin] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  const dispatch = useAppDispatch();

  const organizationSettings = getOrganizationSettings();

  const [user, setUser] = useState(getUser());

  // Add this state for copy feedback
  const [copiedWalletId, setCopiedWalletId] = useState(null);
  const [wallets, setWallets] = useState([]);

  const { data: walletsData, isLoading } = useWallet();
  // const { data: rateResponse, isLoading: isRateLoading } = useExchangeRate({});

  useEffect(() => {
    if (!walletsData) return;

    setWallets(walletsData.data);

    console.log("This is the arrival");

    fetchTotals(walletsData.data).then(() => {
      console.log("Trying to fetch transactions");

      fetchAllTransactions(walletsData.data);
    });
  }, [walletsData]);

  // Fetch transactions from all wallets
  const fetchAllTransactions = async (passedWallets = null) => {
    let myWallets = [];

    if (passedWallets) {
      myWallets = passedWallets;
    } else {
      myWallets = wallets;
    }

    if (!myWallets) return;
    setTxLoading(true);

    try {
      // Fetch transactions for all wallets in parallel
      const txsPerWallet = await Promise.all(
        myWallets.map(async (wallet) => {
          try {
            const res = await getWalletTransactions({
              items_per_page: 20,
              wallet_number_or_uuid: wallet.wallet_number || wallet.id,
            });

            const mytxs = res?.data?.transactions?.data || [];

            if (mytxs.length > 0) {
              console.log(mytxs.length, "In-Transactions");
            }

            // Add wallet info to each transaction
            return mytxs.map((tx) => ({
              ...tx,
              wallet_info: wallet,
            }));
          } catch (error) {
            console.error(
              `Failed to fetch transactions for wallet ${wallet.wallet_number}:`,
              error
            );
            return [];
          }
        })
      );

      // Flatten the array of arrays
      let allTxs = txsPerWallet.flat();

      // Sort by date (newest first)
      allTxs.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      console.log(allTxs.length, "Final transactions length");

      setAllTransactions(allTxs);
      setTransactions(allTxs);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
    } finally {
      setTxLoading(false);
    }
  };

  // Fetch user balances and exchange rates on component mount
  useEffect(() => {
    // fetchUserBalances();
    // fetchRealExchangeRates();
  }, []);

  // Refresh balances when wallets change
  useEffect(() => {
    if (wallets.length > 0) {
      fetchUserBalances();
    }
  }, [wallets]);

  // Debug useEffect for crypto transfer network
  useEffect(() => {
    console.log("cryptoTransferNetwork state changed:", cryptoTransferNetwork);
  }, [cryptoTransferNetwork]);

  useEffect(() => {
    console.log("Chaing currency", overviewCurrency);

    if (wallets) {
      fetchTotals();
    }
  }, [overviewCurrency]);

  async function fetchTotals(passedWallets = null) {
    console.log("before  wallet");

    let myWallets = [];

    if (passedWallets) {
      myWallets = passedWallets;
    } else {
      myWallets = wallets;
    }

    if (myWallets.length == 0) return;
    setOverviewLoading(true);

    console.log(myWallets.length, "after wallet");

    let total = 0;
    try {
      for (const w of myWallets) {
        console.log("Overview currency", overviewCurrency);

        const from = w.currency?.code;
        const amount = parseFloat(w.balance || 0);

        if (from === overviewCurrency) {
          total += amount;
        }
        // else if (amount > 0) {
        //   try {
        //     const res = await getExchangeRate({
        //       from: from.substr(0, 3),
        //       to: overviewCurrency,
        //       amount: amount,
        //     });
        //     if (res.status && res.data && res.data.quote_amount) {
        //       total += parseFloat(res.data.quote_amount);
        //     } else if (res.status && res.data && res.data.exchange_rate) {
        //       total += amount * res.data.exchange_rate;
        //     }
        //   } catch (error) {
        //     console.error(
        //       `Failed to convert ${from} to ${overviewCurrency}:`,
        //       error
        //     );
        //   }
        // }
      }
      console.log(total, "The second wallet amount");

      setOverviewTotal(total);
    } catch (e) {
      console.error("Failed to calculate total:", e);
      setOverviewTotal(0);
    }
    setOverviewLoading(false);
  }

  const toggleBalanceVisibility = (walletId) => {
    setShowBalances((prev) => ({
      ...prev,
      [walletId]: !prev[walletId],
    }));
  };

  const handleViewTransaction = (transaction) => {
    setSelectedTransaction(transaction);
    setOpen(true);
  };

  const handleWalletClick = async (wallet) => {
    setSelectedWalletForDetails(wallet);
    setWalletDetailsOpen(true);
    setSelectedWalletTxLoading(true);

    try {
      const res = await getWalletTransactions({
        items_per_page: 20,
        wallet_number_or_uuid: wallet.wallet_number || wallet.id,
      });

      let txs = [];
      if (
        res &&
        res.data &&
        res.data.transactions &&
        res.data.transactions.data
      ) {
        txs = res.data.transactions.data;
      } else if (res && res.data.transactions && res.data.transactions.data) {
        txs = res.data.transactions.data;
      }
      setSelectedWalletTransactions(txs);
    } catch (error) {
      console.error("Failed to load wallet transactions:", error);
      setSelectedWalletTransactions([]);
    } finally {
      setSelectedWalletTxLoading(false);
    }
  };

  const handleCloseWalletDetails = () => {
    setWalletDetailsOpen(false);
    setSelectedWalletForDetails(null);
    setSelectedWalletTransactions([]);
  };

  const handleViewAllTransactions = async () => {
    setAllTransactionsOpen(true);
    setAllTransactionsLoading(true);

    try {
      // Get transactions from all wallets
      let allTxs = [];
      for (const wallet of wallets) {
        const res = await getWalletTransactions({
          items_per_page: 50,
          wallet_number_or_uuid: wallet.wallet_number || wallet.id,
        });

        let txs = [];
        if (
          res &&
          res.data &&
          res.data.transactions &&
          res.data.transactions.data
        ) {
          txs = res.data.transactions.data;
        } else if (res && res.data.transactions && res.data.transactions.data) {
          txs = res.data.transactions.data;
        }

        // Add wallet info to each transaction
        txs = txs.map((tx) => ({
          ...tx,
          wallet_currency: wallet.currency?.code,
          wallet_symbol: wallet.currency?.symbol,
        }));

        allTxs = [...allTxs, ...txs];
      }

      // Sort by date (newest first)
      allTxs.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      console.log(allTxs[0], "First Created At");

      setAllTransactions(allTxs);
    } catch (error) {
      console.error("Failed to load all transactions:", error);
      setAllTransactions([]);
    } finally {
      setAllTransactionsLoading(false);
    }
  };

  const fetchUserBalances = async () => {
    try {
      // Use the wallets data we already have
      const balances = {};
      wallets.forEach((wallet) => {
        const currencyCode = wallet.currency?.code;
        if (currencyCode) {
          balances[currencyCode] = {
            balance: parseFloat(wallet.balance || 0),
            symbol: wallet.currency?.symbol || getSymbol(currencyCode),
          };
        }
      });
      setUserBalances(balances);
    } catch (error) {
      console.error("Failed to fetch user balances:", error);
    }
  };

  const fetchRealExchangeRates = async () => {
    setRatesLoading(true);
    try {
      const rates = {};

      // Get exchange rates for supported currencies using your API
      const supportedCurrencies = ["NGN", "USD", "GBP", "USDT"];

      for (const fromCurrency of supportedCurrencies) {
        for (const toCurrency of supportedCurrencies) {
          if (fromCurrency !== toCurrency) {
            try {
              const response = await getExchangeRate({
                from: fromCurrency.substr(0, 3),
                to: toCurrency,
                amount: 1,
              });

              if (
                response.status &&
                response.data &&
                response.data.exchange_rate
              ) {
                rates[`${fromCurrency}-${toCurrency}`] =
                  response.data.exchange_rate;
              }
            } catch (error) {
              console.error(
                `Failed to get rate for ${fromCurrency}-${toCurrency}:`,
                error
              );
            }
          }
        }
      }

      setRealRates(rates);
      setRates(rates);
    } catch (error) {
      console.error("Failed to fetch exchange rates:", error);
    } finally {
      setRatesLoading(false);
    }
  };

  const handleViewRates = async () => {
    setRatesOpen(true);
    // await fetchRealExchangeRates();
  };

  const handleSwap = async () => {
    if (!swapFromAmount || parseFloat(swapFromAmount) <= 0) {
      setSwapError("Please enter a valid amount");
      return;
    }

    // Find source and destination wallets
    const sourceWallet = wallets.find(
      (w) => w.currency?.code === swapFromCurrency
    );
    const destinationWallet = wallets.find(
      (w) => w.currency?.code === swapToCurrency
    );

    if (!sourceWallet || !destinationWallet) {
      setSwapError("Please select valid source and destination wallets");
      return;
    }

    // Check if user has sufficient balance
    const sourceBalance = parseFloat(sourceWallet.balance || 0);
    if (parseFloat(swapFromAmount) > sourceBalance) {
      setSwapError(
        `Insufficient balance. You have ${sourceBalance} ${swapFromCurrency}`
      );
      return;
    }

    setSwapLoading(true);
    setSwapError("");

    try {
      // Get real exchange rate from API
      const rateResponse = await getExchangeRate({
        from: swapFromCurrency,
        to: swapToCurrency,
        amount: parseFloat(swapFromAmount),
      });

      if (rateResponse.status && rateResponse.data) {
        const calculatedAmount =
          rateResponse.data.quote_amount ||
          rateResponse.data.exchange_rate * parseFloat(swapFromAmount);
        setSwapToAmount(calculatedAmount.toFixed(6));

        // Open swap dialog for confirmation
        setSwapFromWallet(sourceWallet);
        setSwapToWallet(destinationWallet);
        setSwapDescription(
          `Swap ${swapFromAmount} ${swapFromCurrency} to ${swapToAmount} ${swapToCurrency}`
        );
        setSwapStep(1);
        setSwapDialogOpen(true);
        setSwapError("");
      } else {
        setSwapError("Failed to get exchange rate. Please try again.");
      }
    } catch (error) {
      console.error("Swap failed:", error);
      setSwapError("Swap failed. Please try again.");
    } finally {
      setSwapLoading(false);
    }
  };

  const handleSwapFromAmountChange = async (value) => {
    setSwapFromAmount(value);
    setSwapError("");

    if (value && parseFloat(value) > 0) {
      try {
        // Get real exchange rate from API
        const rateResponse = await getExchangeRate({
          from: swapFromCurrency,
          to: swapToCurrency,
          amount: parseFloat(value),
        });

        if (rateResponse.status && rateResponse.data) {
          const calculatedAmount =
            rateResponse.data.quote_amount ||
            rateResponse.data.exchange_rate * parseFloat(value);
          setSwapToAmount(calculatedAmount.toFixed(6));
        }
      } catch (error) {
        console.error("Failed to get exchange rate:", error);
        // Fallback to stored rate if available
        const realRate =
          realRates[`${swapFromCurrency}-${swapToCurrency}`] || 1.0;
        const calculatedAmount = parseFloat(value) * realRate;
        setSwapToAmount(calculatedAmount.toFixed(6));
      }
    } else {
      setSwapToAmount("");
    }
  };

  const handleSwapCurrencyChange = async (type, currency) => {
    if (type === "from") {
      setSwapFromCurrency(currency);
    } else {
      setSwapToCurrency(currency);
    }

    // Recalculate if we have an amount
    if (swapFromAmount && parseFloat(swapFromAmount) > 0) {
      try {
        const fromCurrency = type === "from" ? currency : swapFromCurrency;
        const toCurrency = type === "from" ? swapToCurrency : currency;

        // Get real exchange rate from API
        const rateResponse = await getExchangeRate({
          from: fromCurrency.substr(0, 3),
          to: toCurrency,
          amount: parseFloat(swapFromAmount),
        });

        if (rateResponse.status && rateResponse.data) {
          const calculatedAmount =
            rateResponse.data.quote_amount ||
            rateResponse.data.exchange_rate * parseFloat(swapFromAmount);
          setSwapToAmount(calculatedAmount.toFixed(6));
        }
      } catch (error) {
        console.error("Failed to get exchange rate:", error);
        // Fallback to stored rate if available
        const realRate =
          realRates[
          `${type === "from" ? currency : swapFromCurrency}-${type === "from" ? swapToCurrency : currency
          }`
          ] || 1.0;
        const calculatedAmount = parseFloat(swapFromAmount) * realRate;
        setSwapToAmount(calculatedAmount.toFixed(6));
      }
    }
  };

  // Swap dialog handlers
  const handleSwapStep1 = () => {
    if (!swapPin || swapPin.length !== 4) {
      setSwapError("Please enter a valid 4-digit transaction PIN");
      return;
    }
    setSwapStep(2);
    setSwapError("");
  };

  const handleSwapStep2 = async () => {
    setSwapLoading(true);
    setSwapError("");

    try {
      // First, initiate the swap transaction
      const initiateRes = await initiateWalletSwap({
        source_wallet_number_or_uuid: swapFromWallet.wallet_number,
        source_wallet_swap_amount: parseFloat(swapFromAmount),
        destination_wallet_number_or_uuid: swapToWallet.wallet_number,
        description: swapDescription,
        transaction_pin: parseInt(swapPin),
      });

      if (initiateRes.status && initiateRes.data) {
        // Then process the swap with transaction pin
        const processRes = await processWalletSwap({
          source_wallet_number_or_uuid: swapFromWallet.wallet_number,
          source_wallet_swap_amount: parseFloat(swapFromAmount),
          destination_wallet_number_or_uuid: swapToWallet.wallet_number,
          description: swapDescription,
          transaction_pin: parseInt(swapPin),
        });

        if (processRes.status) {
          setSwapResult(processRes.data);
          setSwapStep(3);
          setSnackbarMsg("Wallet swap completed successfully!");
          setSnackbarOpen(true);

          // Refresh wallets and transactions
          const walletsData = await getWallets();
          const walletsArr =
            (walletsData && walletsData.data && walletsData.data.data) || [];

          // Refresh transactions
          // await fetchAllTransactions();
        } else {
          setSwapError(processRes.message || "Swap processing failed.");
        }
      } else {
        setSwapError(initiateRes.message || "Swap initiation failed.");
      }
    } catch (e) {
      setSwapError(
        e?.response?.data?.message || "Swap failed. Please try again."
      );
    }
    setSwapLoading(false);
  };

  const handleCloseSwapDialog = () => {
    setSwapDialogOpen(false);
    setSwapStep(1);
    setSwapFromWallet(null);
    setSwapToWallet(null);
    setSwapDescription("");
    setSwapPin("");
    setSwapResult(null);
    setSwapError("");
    setShowSwapPin(false);
  };

  // Crypto transfer handlers
  const handleOpenCryptoTransferDialog = (wallet) => {
    console.log("Opening crypto transfer dialog for wallet:", wallet);
    console.log("Wallet currency code:", wallet.currency?.code);
    console.log("Is crypto wallet:", isCryptoWallet(wallet));

    if (!isCryptoWallet(wallet)) {
      setSnackbarMsg("Only crypto wallets can be used for crypto transfers");
      setSnackbarOpen(true);
      return;
    }
    setCryptoTransferSourceWallet(wallet);
    setCryptoTransferAmount("");
    setCryptoTransferDestinationAddress("");
    // Set default network based on currency
    const defaultNetwork =
      wallet.currency?.code === "USDT"
        ? "TRC20"
        : wallet.currency?.code === "USDC"
          ? "POL"
          : "TRC20";
    console.log("Setting default network:", defaultNetwork);
    console.log(
      "Wallet currency code for network selection:",
      wallet.currency?.code
    );
    setCryptoTransferNetwork(defaultNetwork);
    setCryptoTransferDescription("");
    setCryptoTransferPin("");
    setCryptoTransferStep(1);
    setCryptoTransferError("");
    setCryptoTransferResult(null);
    setCryptoTransferDialogOpen(true);
  };

  const handleCryptoTransferStep1 = () => {
    if (!cryptoTransferAmount || parseFloat(cryptoTransferAmount) <= 0) {
      setCryptoTransferError("Please enter a valid amount");
      return;
    }
    if (
      !cryptoTransferDestinationAddress ||
      cryptoTransferDestinationAddress.trim() === ""
    ) {
      setCryptoTransferError("Please enter a valid destination address");
      return;
    }
    if (!cryptoTransferNetwork) {
      setCryptoTransferError("Please select a network");
      return;
    }

    // Check if user has sufficient balance
    const sourceBalance = parseFloat(cryptoTransferSourceWallet.balance || 0);
    if (parseFloat(cryptoTransferAmount) > sourceBalance) {
      setCryptoTransferError(
        `Insufficient balance. You have ${sourceBalance} ${cryptoTransferSourceWallet.currency?.code}`
      );
      return;
    }

    setCryptoTransferStep(2);
    setCryptoTransferError("");
  };

  const handleCryptoTransferStep2 = async () => {
    if (!cryptoTransferPin || cryptoTransferPin.length !== 4) {
      setCryptoTransferError("Please enter a valid 4-digit transaction PIN");
      return;
    }

    setCryptoTransferLoading(true);
    setCryptoTransferError("");

    try {
      // First, initiate the crypto transfer
      const initiateRes = await initiateCryptoTransfer({
        source_wallet_id: cryptoTransferSourceWallet.id,
        destination_address_code: cryptoTransferDestinationAddress.trim(),
        destination_address_network: cryptoTransferNetwork,
        amount: parseFloat(cryptoTransferAmount),
        description:
          cryptoTransferDescription ||
          `Crypto transfer to ${cryptoTransferDestinationAddress}`,
      });

      if (initiateRes.status && initiateRes.data) {
        // Then process the crypto transfer with transaction pin
        const processRes = await processCryptoTransfer({
          source_wallet_id: cryptoTransferSourceWallet.id,
          destination_address_code: cryptoTransferDestinationAddress.trim(),
          destination_address_network: cryptoTransferNetwork,
          amount: parseFloat(cryptoTransferAmount),
          description:
            cryptoTransferDescription ||
            `Crypto transfer to ${cryptoTransferDestinationAddress}`,
          transaction_pin: parseInt(cryptoTransferPin),
        });

        if (processRes.status) {
          setCryptoTransferResult(processRes.data);
          setCryptoTransferStep(3);
          setSnackbarMsg("Crypto transfer initiated successfully!");
          setSnackbarOpen(true);

          // Refresh wallets and transactions
          const walletsData = await getWallets();
          const walletsArr =
            (walletsData && walletsData.data && walletsData.data.data) || [];

          // Refresh transactions
          // await fetchAllTransactions();
        } else {
          setCryptoTransferError(
            processRes.message || "Crypto transfer processing failed."
          );
        }
      } else {
        setCryptoTransferError(
          initiateRes.message || "Crypto transfer initiation failed."
        );
      }
    } catch (e) {
      setCryptoTransferError(
        e?.response?.data?.message ||
        "Crypto transfer failed. Please try again."
      );
    }
    setCryptoTransferLoading(false);
  };

  const handleCloseCryptoTransferDialog = () => {
    setCryptoTransferDialogOpen(false);
    setCryptoTransferStep(1);
    setCryptoTransferSourceWallet(null);
    setCryptoTransferAmount("");
    setCryptoTransferDestinationAddress("");
    setCryptoTransferNetwork("TRC20");
    setCryptoTransferDescription("");
    setCryptoTransferPin("");
    setCryptoTransferResult(null);
    setCryptoTransferError("");
    setShowCryptoTransferPin(false);
  };

  // --- FUNDING DIALOG HANDLERS ---
  const handleOpenFundDialog = (wallet) => {
    setFundWallet(wallet);
    setFundAmount("");
    setFundCurrency("NGN");
    setFundDesc("");
    setFundPin("");
    setFundStep(1);
    setFundError("");
    setFundResult(null);
    setFundDialogOpen(true);
  };
  const handleFundStep1 = () => {
    if (!fundAmount || Number(fundAmount) <= 0) {
      setFundError("Enter a valid amount");
      return;
    }
    setFundStep(2);
    setFundError("");
  };
  function getValidWalletNumber(wallet) {
    if (!wallet) return null;
    if (wallet.wallet_number && wallet.wallet_number.length > 0) {
      return wallet.wallet_number;
    }
    return null;
  }
  function getSymbol(code) {
    if (code === "NGN") return "₦";
    if (code === "USD" || code === "USDT") return "$";
    if (code === "GBP") return "£";
    return "";
  }
  function getFlag(code) {
    if (code === "NGN") return "🇳🇬";
    if (code === "USD" || code === "USDT") return "🇺🇸";
    if (code === "GBP") return "🇬🇧";
    return "💰";
  }
  const handleFundStep2 = async () => {
    setFunding(true);
    setFundError("");
    const validWalletNumber = getValidWalletNumber(fundWallet);
    if (!validWalletNumber) {
      setFundError(
        "This wallet cannot be funded. Please select a wallet with a valid 10-digit wallet number."
      );
      setFunding(false);
      return;
    }
    try {
      const initiateRes = await initiateWalletFunding({
        funding_amount: Number(fundAmount),
        funding_currency_code: fundCurrency,
        destination_wallet_number_or_uuid: validWalletNumber,
        description: fundDesc || `Wallet funding for ${validWalletNumber}`,
      });
      if (initiateRes.status && initiateRes.data) {
        const processRes = await processWalletFunding({
          funding_amount: Number(fundAmount),
          funding_currency_code: fundCurrency,
          destination_wallet_number_or_uuid: validWalletNumber,
          description: fundDesc || `Wallet funding for ${validWalletNumber}`,
          transaction_pin: fundPin,
          success_redirect_url: `${window.location.origin}/dashboard?status=success`,
          cancelled_redirect_url: `${window.location.origin}/dashboard?status=cancelled`,
          failed_redirect_url: `${window.location.origin}/dashboard?status=failed`,
        });
        if (processRes.status) {
          setFundResult(processRes.data);
          setFundStep(3);
          setSnackbarMsg("Wallet funding initialized successfully!");
          setSnackbarOpen(true);
        } else {
          setFundError(processRes.message || "Funding processing failed.");
        }
      } else {
        setFundError(initiateRes.message || "Funding initiation failed.");
      }
    } catch (e) {
      setFundError(
        e?.response?.data?.message || "Funding failed. Please try again."
      );
    }
    setFunding(false);
  };

  // Filter transactions based on active tab
  const getFilteredTransactions = () => {
    if (activeTab === "all") {
      return allTransactions;
    } else if (activeTab === "fiat") {
      return allTransactions.filter((tx) => {
        const currency =
          tx.user_wallet?.currency?.code || tx.wallet_info?.currency?.code;
        return ["NGN", "USD", "GBP"].includes(currency);
      });
    } else if (activeTab === "crypto") {
      return allTransactions.filter((tx) => {
        const currency =
          tx.user_wallet?.currency?.code || tx.wallet_info?.currency?.code;
        return [
          "USDT",
          "BTC",
          "ETH",
          "BNB",
          "ADA",
          "DOT",
          "LINK",
          "LTC",
          "BCH",
          "XRP",
        ].includes(currency);
      });
    }

    console.log(allTransactions.length, "All transactions length");

    return allTransactions;
  };

  if (isLoading)
    return <Preloader fullScreen={true} message="Loading your dashboard..." />;
  if (error)
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
        <div className="fintech-card p-8 text-center max-w-md">
          <div className="w-16 h-16 bg-danger-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <AccountBalanceWalletIcon className="text-danger-600 text-2xl" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Failed to Load Dashboard
          </h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary"
          >
            Try Again
          </button>
        </div>
      </div>
    );

  // Helper for icon
  function getWalletIcon(code) {
    if (!code) return <FaDollarSign className="text-2xl" />;
    if (code === "NGN") return <span className="text-2xl">🇳🇬</span>;
    if (code === "USD") return <span className="text-2xl">🇺🇸</span>;
    if (code === "GBP") return <FaSterlingSign className="text-2xl" />;
    if (code === "USDT") return <SiTether className="text-2xl" />;
    if (code === "USDC") return <FaBitcoin className="text-2xl" />; // USDC uses Bitcoin icon
    // All other crypto currencies use Bitcoin icon
    if (
      ["BTC", "ETH", "BNB", "ADA", "DOT", "LINK", "LTC", "BCH", "XRP"].includes(
        code
      )
    ) {
      return <FaBitcoin className="text-2xl" />;
    }
    return <FaDollarSign className="text-2xl" />;
  }

  // Helper to safely render any field that might be an object
  function safeRender(field, fallback = "-") {
    if (typeof field === "object" && field !== null) {
      return field.label || field.slug || field.name || field.id || fallback;
    }
    return field || fallback;
  }

  // Helper to safely render status values
  function getStatusDisplay(status) {
    if (typeof status === "object" && status !== null) {
      return status.label || status.slug || "Unknown";
    }
    return status || "Unknown";
  }

  // Helper to get status color class
  function getStatusColorClass(status) {
    const statusText = getStatusDisplay(status).toLowerCase();
    if (statusText === "success" || statusText === "successful") {
      return "bg-green-100 text-green-800";
    } else if (statusText === "pending") {
      return "bg-yellow-100 text-yellow-800";
    } else {
      return "bg-gray-100 text-gray-800";
    }
  }

  // Helper to get status dot color
  function getStatusDotColor(status) {
    const statusText = getStatusDisplay(status).toLowerCase();
    if (statusText === "success" || statusText === "successful") {
      return "bg-green-400";
    } else if (statusText === "pending") {
      return "bg-yellow-400";
    } else {
      return "bg-gray-400";
    }
  }

  // Helper to trim wallet numbers/addresses
  function trimWalletNumber(num) {
    if (!num) return "-";
    if (num.length <= 16) return num;
    return num.slice(0, 6) + "..." + num.slice(-4);
  }

  // Helper to parse provider_metadata and get network
  function getWalletNetwork(wallet) {
    if (!wallet) return "-";
    if (wallet.network) return wallet.network;
    if (wallet.provider_metadata) {
      try {
        const meta =
          typeof wallet.provider_metadata === "string"
            ? JSON.parse(wallet.provider_metadata)
            : wallet.provider_metadata;
        if (meta.network) return meta.network;
        if (meta.chain) return meta.chain;
        if (meta.network_name) return meta.network_name;
      } catch { }
    }
    return "-";
  }

  // Helper function to determine if wallet is crypto
  function isCryptoWallet(wallet) {
    const cryptoCurrencies = [
      "BTC",
      "ETH",
      "USDT",
      "USDC",
      "BNB",
      "ADA",
      "DOT",
      "LINK",
      "LTC",
      "BCH",
      "XRP",
    ];
    return cryptoCurrencies.includes(wallet.currency?.code);
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 sm:gap-4">

            <div className="min-w-0 flex-1">
              <h1 className="text-xl sm:text-2xl font-bold text-gray-900 truncate">
                Dashboard
              </h1>
              <p className="text-sm text-gray-600 truncate">
                Welcome back, {user?.first_name || user?.username || "User"} 👋
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 sm:gap-4">
            <button
              onClick={handleViewRates}
              className="hidden sm:block text-sm text-gray-600 hover:text-gray-900"
            >
              View FX Rates &gt;
            </button>
            <button
              onClick={() => (window.location.href = "/settings")}
              className="text-gray-600 hover:text-gray-900 p-1"
              title="Settings"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 sm:px-6 py-6 sm:py-8 relative z-10">
        {/* Welcome Header */}
        <div className="mb-6 sm:mb-8 animate-fade-in">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 gap-4">
            <div className="flex-1">
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                Welcome back,{" "}
                <span className="gradient-text">
                  {user?.first_name || user?.username || "User"}
                </span>{" "}
                👋
              </h1>
              <p className="text-gray-600 text-base sm:text-lg">
                Here's what's happening with your finances today
              </p>
            </div>
            <div className="flex items-center space-x-3">
              <div className="relative">
                <div className="w-3 h-3 bg-success-500 rounded-full animate-pulse"></div>
                <div className="absolute inset-0 w-3 h-3 bg-success-500 rounded-full animate-ping opacity-75"></div>
              </div>
              <span className="text-sm text-success-600 font-medium">Live</span>
            </div>
          </div>
        </div>

        {/* Total Assets Section - Enhanced */}
        <div className="mb-6 sm:mb-8 animate-slide-up">
          <div className="fintech-card p-6 sm:p-8 bg-gradient-to-br from-white/80 to-white/60 backdrop-blur-xl border border-white/30">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 gap-4">
              <div>
                <h2 className="text-lg font-semibold text-gray-700 mb-1">
                  Total Portfolio Value
                </h2>
                <p className="text-sm text-gray-500">
                  Across all your accounts
                </p>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-success-500 rounded-full"></div>
                <span className="text-sm text-success-600 font-medium">
                  +2.4% today
                </span>
              </div>
            </div>
            <div className="flex items-center gap-2 mb-2">
              <div className="relative inline-block">
                <select
                  value={overviewCurrency}
                  onChange={(e) => setOverviewCurrency(e.target.value)}
                  className="appearance-none text-2xl sm:text-3xl font-bold gradient-text bg-transparent border-none focus:ring-0 cursor-pointer pr-8"
                >
                  {supportedCurrencies.map((cur) => (
                    <option key={cur} value={cur} className="text-gray-800">
                      {cur}
                    </option>
                  ))}
                </select>

                {/* Dropdown Icon */}
                <svg
                  className="w-5 h-5 absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>

              <div className="text-3xl sm:text-4xl font-bold gradient-text">
                {overviewLoading ? (
                  <div className="loading-skeleton h-12 w-48 rounded-lg"></div>
                ) : (
                  `${getSymbol(overviewCurrency)}${moneyFormat(overviewTotal)}`
                )}
              </div>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-4 text-sm">
              <span className="text-gray-500">
                Last updated: {new Date().toLocaleTimeString()}
              </span>
              <div className="flex items-center space-x-1">
                <span className="text-success-600">↗</span>
                <span className="text-success-600 font-medium">
                  {getSymbol(overviewCurrency)}
                  {overviewTotal > 0
                    ? (overviewTotal * 0.05).toFixed(2)
                    : "0.00"}
                </span>
                <span className="text-gray-500">this week</span>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="mt-6 pt-6 border-t border-gray-200/50">
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                {organizationSettings.organization_subscribed_features[
                  "vtu-mgt"
                ] && (
                    <button
                      onClick={() => (window.location.href = "/bills")}
                      className="flex-1 sm:flex-none px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8h18M3 12h18m-2 4H5a2 2 0 01-2-2V8a2 2 0 012-2h14a2 2 0 012 2v6a2 2 0 01-2 2z"
                        />
                      </svg>

                      <span>Pay Bills</span>
                    </button>
                  )}

                {organizationSettings.organization_subscribed_features[
                  "cross-border-payment-mgt"
                ] &&
                  organizationSettings.customized_app_displayable_menu_items[
                  "display-fiat-crypto-conversion-options"
                  ] && (
                    <button
                      onClick={() => setSwapDialogOpen(true)}
                      className="flex-1 sm:flex-none px-4 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-medium rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                    >
                      <SwapHorizIcon className="w-5 h-5" />
                      <span>Convert Fund</span>
                    </button>
                  )}

                {organizationSettings.organization_subscribed_features[
                  "payments-manager"
                ] &&
                  organizationSettings.customized_app_displayable_menu_items[
                  "display-bank-transfer-menu"
                  ] && (
                    <button
                      onClick={() => (window.location.href = "/payment")}
                      className="flex-1 sm:flex-none px-4 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-medium rounded-xl hover:from-purple-700 hover:to-purple-800 transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                        />
                      </svg>
                      <span>Send Money</span>
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>

        {/* Currency Balance Cards - Modern Design */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
          {wallets.map((wallet, index) => {
            const code = wallet.currency?.code;
            const symbol = wallet.currency?.symbol || "";
            const balance = parseFloat(wallet.balance || 0);

            // Define color schemes based on currency type
            const getCardColors = (code) => {
              // Use the same color scheme for all cards
              return {
                bg: "from-blue-50 to-blue-100",
                icon: "bg-blue-100",
                text: "text-blue-600",
                border: "border-blue-200/50",
              };
            };

            const colors = getCardColors(code);

            return (
              <div
                key={wallet.id}
                className={`fintech-card p-6 bg-gradient-to-br ${colors.bg} border ${colors.border} animate-slide-up cursor-pointer hover:shadow-lg transition-all duration-300`}
                style={{ animationDelay: `${index * 100}ms` }}
                onClick={() => handleWalletClick(wallet)}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div
                    className={`w-12 h-12 ${colors.icon} rounded-2xl flex items-center justify-center`}
                  >
                    <div className={colors.text}>{getWalletIcon(code)}</div>
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className={`text-sm ${colors.text} font-medium`}>
                      {code === "USDT"
                        ? "Tether USD"
                        : code === "USDC"
                          ? "USD Coin"
                          : code === "NGN"
                            ? "Nigerian Naira"
                            : code === "USD"
                              ? "US Dollar"
                              : code === "GBP"
                                ? "British Pound"
                                : `${code} Wallet`}
                    </div>
                    <div className="text-2xl font-bold text-gray-900">
                      {showBalances[wallet.id]
                        ? `${symbol}${balance.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}`
                        : `${symbol}••••••••`}
                    </div>
                  </div>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleBalanceVisibility(wallet.id);
                    }}
                    size="small"
                    className="text-gray-400 hover:text-gray-600 hover:bg-gray-100/50 rounded-xl transition-all duration-200 flex-shrink-0"
                  >
                    {showBalances[wallet.id] ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </IconButton>
                </div>

                {/* Bank Name if available */}
                {wallet.bank && wallet.bank.name && (
                  <div className="mb-2 px-1">
                    <span className="text-xs font-semibold text-gray-600">
                      {wallet.bank.name}
                    </span>
                  </div>
                )}

                {/* Account Number */}
                <div className="mb-4">
                  <div className="text-xs text-gray-500 bg-white/50 px-3 py-2 rounded-lg flex items-center justify-between">
                    <span className="truncate font-mono">
                      Acct: {trimWalletNumber(wallet.wallet_number)}
                    </span>
                    {wallet.wallet_number && (
                      <Tooltip
                        title={
                          copiedWalletId === wallet.id ? "Copied!" : "Copy"
                        }
                        placement="top"
                        arrow
                      >
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(wallet.wallet_number);
                            setCopiedWalletId(wallet.id);
                            setTimeout(() => setCopiedWalletId(null), 1200);
                          }}
                          style={{ padding: 2, marginLeft: 4 }}
                          className="flex-shrink-0"
                        >
                          <ContentCopyIcon
                            fontSize="inherit"
                            style={{ fontSize: 12 }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                </div>

                {/* Status and Actions */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                    <span className="text-xs text-green-600 font-medium">
                      Active
                    </span>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex gap-2">
                    {isCryptoWallet(wallet) && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenCryptoTransferDialog(wallet);
                        }}
                        className={`text-xs py-2 px-3 rounded-lg font-medium border transition-all duration-200 ${colors.text
                          .replace("text-", "border-")
                          .replace("-600", "-300") +
                          " " +
                          colors.text +
                          " hover:bg-white/50"
                          }`}
                        disabled={!wallet.wallet_number}
                      >
                        Send Crypto
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Recent Transactions Section - Enhanced */}
        <div className="fintech-card animate-slide-up">
          <div className="px-4 sm:px-6 py-4 border-b border-gray-100/50">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <h3 className="text-xl font-bold text-gray-900">
                  Recent Transactions
                </h3>
                <p className="text-sm text-gray-500">
                  Your latest financial activity
                </p>
              </div>
              <button
                onClick={handleViewAllTransactions}
                className="btn-secondary text-sm py-2 px-4 self-start sm:self-center"
              >
                View All
              </button>
            </div>
          </div>

          <div className="px-4 sm:px-6 py-4">
            <div className="flex space-x-4 mb-6">
              <button
                className={`px-4 py-2 text-sm font-semibold rounded-xl transition-all duration-300 ${activeTab === "all"
                  ? "bg-primary-100 text-primary-700 border border-primary-200"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                  }`}
                onClick={() => setActiveTab("all")}
              >
                All
              </button>
              <button
                className={`px-4 py-2 text-sm font-semibold rounded-xl transition-all duration-300 ${activeTab === "fiat"
                  ? "bg-primary-100 text-primary-700 border border-primary-200"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                  }`}
                onClick={() => setActiveTab("fiat")}
              >
                Fiat
              </button>
              <button
                className={`px-4 py-2 text-sm font-semibold rounded-xl transition-all duration-300 ${activeTab === "crypto"
                  ? "bg-primary-100 text-primary-700 border border-primary-200"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                  }`}
                onClick={() => setActiveTab("crypto")}
              >
                Crypto
              </button>
            </div>

            <div className="overflow-x-auto rounded-xl border border-gray-100/50">
              <table className="fintech-table min-w-full">
                <thead>
                  <tr className="bg-gray-50/50">
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Account</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {txLoading ? (
                    <tr>
                      <td colSpan={6} className="text-center py-12">
                        <div className="flex items-center justify-center space-x-2">
                          <div className="w-6 h-6 border-2 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
                          <span className="text-gray-500">
                            Loading transactions...
                          </span>
                        </div>
                      </td>
                    </tr>
                  ) : getFilteredTransactions().length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center py-12">
                        <div className="text-gray-500">
                          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <SwapHorizIcon className="text-gray-400" />
                          </div>
                          <p className="font-medium">
                            No {activeTab === "all" ? "" : activeTab}{" "}
                            transactions found
                          </p>
                          <p className="text-sm">
                            Your transaction history will appear here
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    getFilteredTransactions()
                      .slice(0, 8)
                      .map((tx) => (
                        <tr
                          key={tx.id}
                          className="hover:bg-gray-50/50 transition-colors duration-200"
                        >
                          <td className="text-sm text-gray-900 font-medium">
                            {tx?.created_at
                              ? new Date(tx.created_at).toLocaleDateString()
                              : "-"}
                          </td>
                          <td className="text-sm font-bold text-gray-900">
                            {tx.user_wallet?.currency?.symbol ||
                              tx.wallet_info?.currency?.symbol ||
                              "₦"}
                            {parseFloat(tx.user_amount || 0).toLocaleString(
                              undefined,
                              { minimumFractionDigits: 2 }
                            )}
                          </td>
                          <td className="text-sm text-gray-900">
                            <div className="flex items-center gap-2">
                              {/* <div className="w-6 h-6 bg-primary-100 rounded-lg flex items-center justify-center"> */}
                              {/* {getWalletIcon(
                                  tx.user_wallet?.currency?.code ||
                                  tx.wallet_info?.currency?.code
                                )} */}
                              {/* </div> */}
                              {tx.user_wallet?.currency?.code ||
                                tx.wallet_info?.currency?.code ||
                                "NGN"}
                            </div>
                          </td>
                          <td className="text-sm text-gray-900">
                            {safeRender(tx.transaction_type)}
                          </td>
                          <td>
                            <StatusPill status={tx.status.label} />

                          </td>
                          <td>
                            <button onClick={() => handleViewTransaction(tx)} className="text-sm text-primary-600 hover:text-primary-800 font-medium transition-colors duration-200">
                              View
                            </button>
                          </td>
                        </tr>
                      ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <TransactionDetailsDialog
          open={open}
          onClose={() => setOpen(false)}
          transaction={selectedTransaction}
        />

        {/* Swap Assets Section - Enhanced */}
        {organizationSettings.organization_subscribed_features[
          "cross-border-payment-mgt"
        ] &&
          organizationSettings.customized_app_displayable_menu_items[
          "display-fiat-crypto-conversion-options"
          ] && (
            <div className="mt-6 sm:mt-8 fintech-card p-6 sm:p-8 animate-slide-up">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">
                    Swap Assets
                  </h3>
                  <p className="text-sm text-gray-500">
                    Convert between different currencies instantly
                  </p>
                </div>
                <button
                  onClick={handleViewRates}
                  className="btn-secondary text-sm py-2 px-4 self-start sm:self-center"
                >
                  View Rates
                </button>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <label className="block text-sm font-semibold text-gray-700">
                    You give
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      placeholder="0.00"
                      value={swapFromAmount}
                      onChange={(e) =>
                        handleSwapFromAmountChange(e.target.value)
                      }
                      className="input-field pr-24"
                    />
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                      <div className="flex items-center gap-2">
                        <span className="text-sm text-gray-500">
                          Bal.{" "}
                          {userBalances[swapFromCurrency]?.symbol ||
                            getSymbol(swapFromCurrency)}
                          {userBalances[swapFromCurrency]?.balance?.toFixed(
                            2
                          ) || "0.00"}
                        </span>
                        <select
                          value={swapFromCurrency}
                          onChange={(e) =>
                            handleSwapCurrencyChange("from", e.target.value)
                          }
                          className="px-3 py-1 bg-primary-100 rounded-lg text-sm font-semibold border-none focus:ring-2 focus:ring-primary-500/25"
                        >
                          <option value="USDT">USDT</option>
                          <option value="USD">USD</option>
                          <option value="NGN">NGN</option>
                          <option value="GBP">GBP</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  <label className="block text-sm font-semibold text-gray-700">
                    You receive
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      placeholder="0.00"
                      value={swapToAmount}
                      readOnly
                      className="input-field pr-24 bg-gray-50"
                    />
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                      <select
                        value={swapToCurrency}
                        onChange={(e) =>
                          handleSwapCurrencyChange("to", e.target.value)
                        }
                        className="px-3 py-1 bg-primary-100 rounded-lg text-sm font-semibold border-none focus:ring-2 focus:ring-primary-500/25"
                      >
                        <option value="USD">USD</option>
                        <option value="USDT">USDT</option>
                        <option value="NGN">NGN</option>
                        <option value="GBP">GBP</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {swapError && (
                <div className="mt-4 p-3 bg-danger-50 border border-danger-200 rounded-xl">
                  <p className="text-sm text-danger-700">{swapError}</p>
                </div>
              )}

              <button
                onClick={handleSwap}
                disabled={
                  swapLoading ||
                  !swapFromAmount ||
                  parseFloat(swapFromAmount) <= 0
                }
                className="w-full btn-primary mt-6"
              >
                {swapLoading ? (
                  <div className="flex items-center justify-center space-x-2">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Processing Swap...</span>
                  </div>
                ) : (
                  "Swap Assets"
                )}
              </button>
            </div>
          )}
      </main>

      {/* Wallet Details Modal */}
      <Dialog
        open={walletDetailsOpen}
        onClose={handleCloseWalletDetails}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {selectedWalletForDetails &&
              getWalletIcon(selectedWalletForDetails.currency?.code)}
            <span className="text-xl font-bold text-gray-900">
              {selectedWalletForDetails?.currency?.name ||
                selectedWalletForDetails?.currency?.code ||
                "Wallet"}{" "}
              Details
            </span>
          </div>
          <IconButton onClick={handleCloseWalletDetails}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedWalletForDetails && (
            <div className="space-y-6">
              {/* Wallet Information */}
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Wallet Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-sm font-medium text-gray-500">
                      Account Number
                    </label>
                    <div className="flex items-center gap-1">
                      <span className="text-sm text-gray-900 font-mono">
                        {selectedWalletForDetails.wallet_number || "-"}
                      </span>
                      {selectedWalletForDetails.wallet_number && (
                        <Tooltip
                          title={
                            copiedWalletId === selectedWalletForDetails.id
                              ? "Copied!"
                              : "Copy"
                          }
                          placement="top"
                          arrow
                        >
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigator.clipboard.writeText(
                                selectedWalletForDetails.wallet_number
                              );
                              setCopiedWalletId(selectedWalletForDetails.id);
                              setTimeout(() => setCopiedWalletId(null), 1200);
                            }}
                            style={{ padding: 2 }}
                          >
                            <ContentCopyIcon
                              fontSize="inherit"
                              style={{ fontSize: 14 }}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  {isCryptoWallet(selectedWalletForDetails) && (
                    <div>
                      <label className="text-sm font-medium text-gray-500">
                        Network
                      </label>
                      <p className="text-sm text-gray-900">
                        {getWalletNetwork(selectedWalletForDetails)}
                      </p>
                    </div>
                  )}
                  {!isCryptoWallet(selectedWalletForDetails) && (
                    <div>
                      <label className="text-sm font-medium text-gray-500">
                        Bank/Provider
                      </label>
                      <p className="text-sm text-gray-900">
                        {selectedWalletForDetails.bank.name}
                      </p>
                    </div>
                  )}
                  <div>
                    <label className="text-sm font-medium text-gray-500">
                      Balance
                    </label>
                    <p className="text-lg font-bold text-gray-900">
                      {selectedWalletForDetails.currency?.symbol || ""}
                      {parseFloat(
                        selectedWalletForDetails.balance || 0
                      ).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">
                      Type
                    </label>
                    <p className="text-sm text-gray-900">
                      {selectedWalletForDetails.type ||
                        selectedWalletForDetails.currency?.type ||
                        "-"}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">
                      Status
                    </label>
                    <p className="text-sm text-gray-900">
                      {typeof selectedWalletForDetails.status === "object"
                        ? selectedWalletForDetails.status?.label ||
                        selectedWalletForDetails.status?.slug ||
                        "-"
                        : selectedWalletForDetails.status || "-"}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-500">
                      Currency
                    </label>
                    <p className="text-sm text-gray-900">
                      {selectedWalletForDetails.currency?.code || "-"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Transaction History */}
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Transaction History
                </h3>
                <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="min-w-full">
                      <thead>
                        <tr className="bg-gray-50 border-b border-gray-200">
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Date
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Amount
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Type
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Description
                          </th>
                          <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Reference
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedWalletTxLoading ? (
                          <tr>
                            <td colSpan={6} className="text-center py-8">
                              <CircularProgress />
                            </td>
                          </tr>
                        ) : selectedWalletTransactions.length === 0 ? (
                          <tr>
                            <td
                              colSpan={6}
                              className="text-center py-8 text-gray-500"
                            >
                              No transactions found for this wallet.
                            </td>
                          </tr>
                        ) : (
                          selectedWalletTransactions.map((tx) => (
                            <tr
                              key={tx.id}
                              className="border-b border-gray-100 hover:bg-gray-50"
                            >
                              <td className="py-3 px-4 text-sm text-gray-900">
                                {tx.created_at
                                  ? new Date(tx.created_at).toLocaleString()
                                  : "-"}
                              </td>
                              <td className="py-3 px-4 text-sm font-medium text-gray-900">
                                {tx.user_wallet?.currency?.symbol ||
                                  selectedWalletForDetails?.currency?.symbol ||
                                  "₦"}
                                {parseFloat(tx.user_amount || 0).toLocaleString(
                                  undefined,
                                  { minimumFractionDigits: 2 }
                                )}
                              </td>
                              <td className="py-3 px-4 text-sm text-gray-900">
                                {safeRender(tx.transaction_type)}
                              </td>
                              <td className="py-3 px-4">
                                <span
                                  className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColorClass(
                                    tx.status
                                  )}`}
                                >
                                  <span
                                    className={`w-2 h-2 rounded-full mr-1 ${getStatusDotColor(
                                      tx.status
                                    )}`}
                                  ></span>
                                  {getStatusDisplay(tx.status)}
                                </span>
                              </td>
                              <td className="py-3 px-4 text-sm text-gray-900">
                                {tx.description || "-"}
                              </td>
                              <td className="py-3 px-4 text-sm text-gray-900 font-mono">
                                {tx.reference_number || "-"}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseWalletDetails} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* All Transactions Modal */}
      <Dialog
        open={allTransactionsOpen}
        onClose={() => setAllTransactionsOpen(false)}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle className="flex items-center justify-between">
          <span className="text-xl font-bold text-gray-900">
            All Transactions
          </span>
          <IconButton onClick={() => setAllTransactionsOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-200">
                  <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Date
                  </th>
                  <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Amount
                  </th>
                  <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Wallet
                  </th>
                  <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Type
                  </th>
                  <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                {allTransactionsLoading ? (
                  <tr>
                    <td colSpan={6} className="text-center py-8">
                      <CircularProgress />
                    </td>
                  </tr>
                ) : allTransactions.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="text-center py-8 text-gray-500">
                      No transactions found.
                    </td>
                  </tr>
                ) : (
                  allTransactions.map((tx) => (
                    <tr
                      key={tx.id}
                      className="border-b border-gray-100 hover:bg-gray-50"
                    >
                      <td className="py-3 px-4 text-sm text-gray-900">
                        {tx.created_at
                          ? new Date(tx.created_at).toLocaleDateString()
                          : "-"}
                      </td>
                      <td className="py-3 px-4 text-sm font-medium text-gray-900">
                        {tx.wallet_symbol ||
                          tx.user_wallet?.currency?.symbol ||
                          "₦"}
                        {parseFloat(tx.user_amount || 0).toLocaleString(
                          undefined,
                          { minimumFractionDigits: 2 }
                        )}
                      </td>
                      <td className="py-3 px-4 text-sm text-gray-900">
                        <div className="flex items-center gap-2">
                          {getWalletIcon(
                            tx.wallet_currency || tx.user_wallet?.currency?.code
                          )}
                          {tx.wallet_currency ||
                            tx.user_wallet?.currency?.code ||
                            "NGN"}
                        </div>
                      </td>
                      <td className="py-3 px-4 text-sm text-gray-900">
                        {safeRender(tx.transaction_type)}
                      </td>
                      <td className="py-3 px-4">
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColorClass(
                            tx.status
                          )}`}
                        >
                          <span
                            className={`w-2 h-2 rounded-full mr-1 ${getStatusDotColor(
                              tx.status
                            )}`}
                          ></span>
                          {getStatusDisplay(tx.status)}
                        </span>
                      </td>
                      <td className="py-3 px-4 text-sm text-gray-900">
                        {tx.description || "-"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAllTransactionsOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Exchange Rates Modal */}
      <Dialog
        open={ratesOpen}
        onClose={() => setRatesOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle className="flex items-center justify-between">
          <span className="text-xl font-bold text-gray-900">
            Exchange Rates
          </span>
          <IconButton onClick={() => setRatesOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {ratesLoading ? (
            <div className="text-center py-8">
              <CircularProgress />
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {Object.entries(rates).map(([pair, rate]) => (
                <div key={pair} className="bg-gray-50 rounded-lg p-4">
                  <div className="flex justify-between items-center">
                    <span className="font-medium text-gray-900">{pair}</span>
                    <span className="text-lg font-bold text-blue-600">
                      {typeof rate === "number" ? rate.toFixed(6) : rate}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRatesOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Funding Dialog */}
      <Dialog
        open={fundDialogOpen}
        onClose={() => setFundDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Fund Wallet</DialogTitle>
        <DialogContent>
          {fundStep === 1 && (
            <>
              <div style={{ marginBottom: 16 }}>
                {fundWallet &&
                  `Fund wallet ${getValidWalletNumber(fundWallet) ||
                  fundWallet.wallet_number ||
                  fundWallet.id
                  }`}
              </div>
              <Select
                value={fundCurrency}
                onChange={(e) => setFundCurrency(e.target.value)}
                fullWidth
                style={{ marginBottom: 16 }}
                disabled={!fundWallet || !getValidWalletNumber(fundWallet)}
              >
                {supportedCurrencies.map((currency) => (
                  <MenuItem key={currency} value={currency}>
                    {getFlag(currency)} {currency}
                  </MenuItem>
                ))}
              </Select>
              <input
                autoFocus
                type="number"
                placeholder="Amount"
                value={fundAmount}
                onChange={(e) => setFundAmount(e.target.value)}
                style={{
                  width: "100%",
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
                disabled={!fundWallet || !getValidWalletNumber(fundWallet)}
              />
              <input
                type="text"
                placeholder="Description (optional)"
                value={fundDesc}
                onChange={(e) => setFundDesc(e.target.value)}
                style={{
                  width: "100%",
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
                disabled={!fundWallet || !getValidWalletNumber(fundWallet)}
              />
              {fundError && (
                <div style={{ color: "red", marginBottom: 8 }}>{fundError}</div>
              )}
            </>
          )}
          {fundStep === 2 && (
            <>
              <div style={{ marginBottom: 16, fontWeight: 600 }}>
                Confirm Funding
              </div>
              <div
                style={{
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  background: "#f5f7fa",
                  fontSize: 15,
                }}
              >
                <div>
                  Amount:{" "}
                  <b>
                    {getSymbol(fundCurrency)}
                    {fundAmount}
                  </b>
                </div>
                <div>
                  Currency: <b>{fundCurrency}</b>
                </div>
                <div>
                  To:{" "}
                  <b>
                    {fundWallet &&
                      (getValidWalletNumber(fundWallet) ||
                        fundWallet.wallet_number ||
                        fundWallet.id)}
                  </b>
                </div>
                {fundDesc && (
                  <div>
                    Description: <b>{fundDesc}</b>
                  </div>
                )}
              </div>
              <input
                type={showFundPin ? "text" : "password"}
                placeholder="Transaction Pin"
                value={fundPin}
                onChange={(e) => setFundPin(e.target.value)}
                maxLength={6}
                style={{
                  width: "100%",
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
              />
              <Button
                onClick={() => setShowFundPin((v) => !v)}
                size="small"
                style={{ marginBottom: 16 }}
              >
                {showFundPin ? "Hide" : "Show"} Pin
              </Button>
              {fundError && (
                <div style={{ color: "red", marginBottom: 8 }}>{fundError}</div>
              )}
            </>
          )}
          {fundStep === 3 && (
            <div style={{ color: "green", fontWeight: 600, marginBottom: 16 }}>
              Funding successful!
            </div>
          )}
        </DialogContent>
        <DialogActions>
          {fundStep === 1 && (
            <Button
              onClick={handleFundStep1}
              color="primary"
              variant="contained"
              disabled={funding}
            >
              Next
            </Button>
          )}
          {fundStep === 2 && (
            <Button
              onClick={handleFundStep2}
              color="primary"
              variant="contained"
              disabled={funding}
            >
              Fund Wallet
            </Button>
          )}
          <Button onClick={() => setFundDialogOpen(false)} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Swap Dialog */}
      <Dialog
        open={swapDialogOpen}
        onClose={handleCloseSwapDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Swap Funds</DialogTitle>
        <DialogContent>
          {swapStep === 1 && (
            <>
              <div style={{ marginBottom: 16, fontWeight: 600 }}>
                Confirm Swap
              </div>
              <div
                style={{
                  marginBottom: 16,
                  padding: 12,
                  borderRadius: 8,
                  background: "#f5f7fa",
                  fontSize: 14,
                }}
              >
                <div style={{ marginBottom: 8 }}>
                  <strong>From:</strong> {swapFromWallet?.wallet_number} (
                  {swapFromCurrency})
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>Amount:</strong> {swapFromAmount} {swapFromCurrency}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>To:</strong> {swapToWallet?.wallet_number} (
                  {swapToCurrency})
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>You'll Receive:</strong> {swapToAmount}{" "}
                  {swapToCurrency}
                </div>
                {swapDescription && (
                  <div style={{ marginBottom: 8 }}>
                    <strong>Description:</strong> {swapDescription}
                  </div>
                )}
              </div>
              <input
                type={showSwapPin ? "text" : "password"}
                placeholder="Transaction PIN (4 digits)"
                value={swapPin}
                onChange={(e) =>
                  setSwapPin(e.target.value.replace(/\D/g, "").slice(0, 4))
                }
                maxLength={4}
                style={{
                  width: "100%",
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
              />
              <Button
                onClick={() => setShowSwapPin((v) => !v)}
                size="small"
                style={{ marginBottom: 16 }}
              >
                {showSwapPin ? "Hide" : "Show"} PIN
              </Button>
              {swapError && (
                <div style={{ color: "red", marginBottom: 8 }}>{swapError}</div>
              )}
            </>
          )}
          {swapStep === 2 && (
            <>
              <div style={{ marginBottom: 16, fontWeight: 600 }}>
                Processing Swap...
              </div>
              <div style={{ textAlign: "center", padding: 20 }}>
                <CircularProgress />
                <div style={{ marginTop: 16 }}>
                  Please wait while we process your swap transaction.
                </div>
              </div>
            </>
          )}
          {swapStep === 3 && (
            <>
              <div
                style={{ marginBottom: 16, fontWeight: 600, color: "green" }}
              >
                Swap Successful!
              </div>
              <div
                style={{
                  marginBottom: 16,
                  padding: 12,
                  borderRadius: 8,
                  background: "#e8f5e8",
                  fontSize: 14,
                }}
              >
                <div style={{ marginBottom: 8 }}>
                  <strong>Transaction ID:</strong>{" "}
                  {swapResult?.data?.reference_number || "N/A"}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>Status:</strong>{" "}
                  {swapResult?.data?.status?.label || "Successful"}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>Amount Swapped:</strong> {swapFromAmount}{" "}
                  {swapFromCurrency} → {swapToAmount} {swapToCurrency}
                </div>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          {swapStep === 1 && (
            <Button
              onClick={handleSwapStep1}
              color="primary"
              variant="contained"
              disabled={swapLoading}
            >
              Confirm Swap
            </Button>
          )}
          {swapStep === 2 && (
            <Button
              onClick={handleSwapStep2}
              color="primary"
              variant="contained"
              disabled={swapLoading}
            >
              Process Swap
            </Button>
          )}
          <Button onClick={handleCloseSwapDialog} color="secondary">
            {swapStep === 3 ? "Close" : "Cancel"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Crypto Transfer Dialog */}
      <Dialog
        open={cryptoTransferDialogOpen}
        onClose={handleCloseCryptoTransferDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Send Crypto</DialogTitle>
        <DialogContent>
          {cryptoTransferStep === 1 && (
            <>
              <div style={{ marginBottom: 16, fontWeight: 600 }}>
                Transfer Details
              </div>
              <div
                style={{
                  marginBottom: 16,
                  padding: 12,
                  borderRadius: 8,
                  background: "#f5f7fa",
                  fontSize: 14,
                }}
              >
                <div style={{ marginBottom: 8 }}>
                  <strong>From:</strong>{" "}
                  {cryptoTransferSourceWallet?.wallet_number} (
                  {cryptoTransferSourceWallet?.currency?.code})
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>Balance:</strong>{" "}
                  {cryptoTransferSourceWallet?.balance}{" "}
                  {cryptoTransferSourceWallet?.currency?.code}
                </div>
              </div>

              <input
                type="number"
                placeholder="Amount to send"
                value={cryptoTransferAmount}
                onChange={(e) => setCryptoTransferAmount(e.target.value)}
                style={{
                  width: "100%",
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
              />

              <input
                type="text"
                placeholder="Destination Address (0x...)"
                value={cryptoTransferDestinationAddress}
                onChange={(e) =>
                  setCryptoTransferDestinationAddress(e.target.value)
                }
                style={{
                  width: "100%",
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
              />

              <select
                value={cryptoTransferNetwork}
                onChange={(e) => {
                  console.log("Network selection changed:", e.target.value);
                  setCryptoTransferNetwork(e.target.value);
                }}
                style={{
                  width: "100%",
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  border: "1px solid #ccc",
                  fontSize: "14px",
                }}
              >
                {cryptoTransferSourceWallet?.currency?.code === "USDT" && (
                  <>
                    <option value="TRC20">TRC20 (Tron)</option>
                    <option value="ERC20">ERC20 (Ethereum)</option>
                  </>
                )}
                {cryptoTransferSourceWallet?.currency?.code === "USDC" && (
                  <option value="POL">POL (Polygon)</option>
                )}
                {/* Fallback for other crypto currencies */}
                {!["USDT", "USDC"].includes(
                  cryptoTransferSourceWallet?.currency?.code
                ) && (
                    <>
                      <option value="TRC20">TRC20 (Tron)</option>
                      <option value="ERC20">ERC20 (Ethereum)</option>
                      <option value="POL">POL (Polygon)</option>
                    </>
                  )}
              </select>

              <div
                style={{
                  fontSize: 12,
                  color: "#666",
                  marginBottom: 16,
                  padding: 8,
                  background: "#f9f9f9",
                  borderRadius: 4,
                }}
              >
                <strong>Supported Networks:</strong>
                <br />
                {cryptoTransferSourceWallet?.currency?.code === "USDT" &&
                  "USDT: TRC20 | ERC20"}
                {cryptoTransferSourceWallet?.currency?.code === "USDC" &&
                  "USDC: POL (Polygon)"}
                {!["USDT", "USDC"].includes(
                  cryptoTransferSourceWallet?.currency?.code
                ) &&
                  `Other Crypto: TRC20 | ERC20 | POL (Currency: ${cryptoTransferSourceWallet?.currency?.code})`}
              </div>

              <input
                type="text"
                placeholder="Description (optional)"
                value={cryptoTransferDescription}
                onChange={(e) => setCryptoTransferDescription(e.target.value)}
                style={{
                  width: "100%",
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
              />

              {cryptoTransferError && (
                <div style={{ color: "red", marginBottom: 8 }}>
                  {cryptoTransferError}
                </div>
              )}
            </>
          )}
          {cryptoTransferStep === 2 && (
            <>
              <div style={{ marginBottom: 16, fontWeight: 600 }}>
                Confirm Transfer
              </div>
              <div
                style={{
                  marginBottom: 16,
                  padding: 12,
                  borderRadius: 8,
                  background: "#f5f7fa",
                  fontSize: 14,
                }}
              >
                <div style={{ marginBottom: 8 }}>
                  <strong>From:</strong>{" "}
                  {cryptoTransferSourceWallet?.wallet_number} (
                  {cryptoTransferSourceWallet?.currency?.code})
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>Amount:</strong> {cryptoTransferAmount}{" "}
                  {cryptoTransferSourceWallet?.currency?.code}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>To:</strong> {cryptoTransferDestinationAddress}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>Network:</strong> {cryptoTransferNetwork}
                </div>
                {cryptoTransferDescription && (
                  <div style={{ marginBottom: 8 }}>
                    <strong>Description:</strong> {cryptoTransferDescription}
                  </div>
                )}
              </div>
              <input
                type={showCryptoTransferPin ? "text" : "password"}
                placeholder="Transaction PIN (4 digits)"
                value={cryptoTransferPin}
                onChange={(e) =>
                  setCryptoTransferPin(
                    e.target.value.replace(/\D/g, "").slice(0, 4)
                  )
                }
                maxLength={4}
                style={{
                  width: "100%",
                  marginBottom: 16,
                  padding: 8,
                  borderRadius: 4,
                  border: "1px solid #ccc",
                }}
              />
              <Button
                onClick={() => setShowCryptoTransferPin((v) => !v)}
                size="small"
                style={{ marginBottom: 16 }}
              >
                {showCryptoTransferPin ? "Hide" : "Show"} PIN
              </Button>
              {cryptoTransferError && (
                <div style={{ color: "red", marginBottom: 8 }}>
                  {cryptoTransferError}
                </div>
              )}
            </>
          )}
          {cryptoTransferStep === 3 && (
            <>
              <div
                style={{ marginBottom: 16, fontWeight: 600, color: "green" }}
              >
                Transfer Initiated!
              </div>
              <div
                style={{
                  marginBottom: 16,
                  padding: 12,
                  borderRadius: 8,
                  background: "#e8f5e8",
                  fontSize: 14,
                }}
              >
                <div style={{ marginBottom: 8 }}>
                  <strong>Transaction ID:</strong>{" "}
                  {cryptoTransferResult?.reference_number || "N/A"}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>Status:</strong>{" "}
                  {cryptoTransferResult?.status?.label || "Pending"}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>Amount:</strong> {cryptoTransferAmount}{" "}
                  {cryptoTransferSourceWallet?.currency?.code}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>To:</strong> {cryptoTransferDestinationAddress}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <strong>Network:</strong> {cryptoTransferNetwork}
                </div>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          {cryptoTransferStep === 1 && (
            <Button
              onClick={handleCryptoTransferStep1}
              color="primary"
              variant="contained"
              disabled={cryptoTransferLoading}
            >
              Next
            </Button>
          )}
          {cryptoTransferStep === 2 && (
            <Button
              onClick={handleCryptoTransferStep2}
              color="primary"
              variant="contained"
              disabled={cryptoTransferLoading}
            >
              Send Crypto
            </Button>
          )}
          <Button onClick={handleCloseCryptoTransferDialog} color="secondary">
            {cryptoTransferStep === 3 ? "Close" : "Cancel"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
